import React from "react";
import { Button } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MoneyApi } from "go-core/api/types";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import FormNumberInput from "go-form/components/FormNumberInput";
import { ReactComponent as BlikSVG } from "../../../../../../../../../images/svg/public/order/paymentMethods/blik-black.svg";
import { OrderTransactionApi, PayOrderData } from "../../../../../../../../../services/Api/Public/types";
import OrderPaymentInfo from "../../OrderPaymentInfo";

interface Props {
	totalPrice: MoneyApi;
	handlePay: (
		paymentData: string,
		callback?: (data: OrderTransactionApi) => Promise<void> | void
	) => (e?: React.BaseSyntheticEvent) => Promise<void>;
	setShowErrorPaymentModal: React.Dispatch<React.SetStateAction<boolean>>;
	setIsProcessing: React.Dispatch<React.SetStateAction<boolean>>;
	form: UseFormReturn<PayOrderData>;
	validatePaymentDataOnClick: () => boolean;
	checkTransaction: (data: OrderTransactionApi) => Promise<void>;
}

const PayViaBlik = ({ totalPrice, handlePay, form, validatePaymentDataOnClick, checkTransaction }: Props) => {
	const { t } = useTranslation();
	const { control, watch } = form;

	const handleOnClick = async () => {
		const token = watch("blikToken")?.toString();

		if (!token) return;

		if (!validatePaymentDataOnClick()) return;

		await handlePay(token, checkTransaction)();
	};

	return (
		<div className="d-flex flex-column button-payment-container">
			<FormNumberInput
				errors={[]}
				name="blikToken"
				control={control}
				suffix=""
				placeholder={t("modules.e_order.field.blik_token.title")}
			/>
			<Button
				disabled={watch("blikToken")?.toString()?.length !== 6}
				className="blik-button"
				onClick={handleOnClick}
			>
				{`${t("modules.e_order.action.pay.title")}: ${FormatMoney(totalPrice)}`}
				<BlikSVG />
			</Button>
			<OrderPaymentInfo
				rulesLink={"https://tpay.com/user/assets/files_for_download/regulamin.pdf"}
				privacyPolicyLink={"https://tpay.com/user/assets/files_for_download/klauzula-informacyjna-platnik.pdf"}
			/>
		</div>
	);
};

export default PayViaBlik;
